{
  "agentStatus": {
    "failed": "not working",
    "not_installed": "not installed",
    "not_logged_in": "not logged in",
    "ready": "ready"
  },
  "connect": {
    "approve": "Approve this PC",
    "approveNote": "The command opens DMW in your browser to approve this PC. Without a browser, it shows a code: enter it here.",
    "download": "Download and install the DMW Connector",
    "enterCode": "Enter the code it shows",
    "installByCommand": "Install the DMW Connector with one command",
    "open": "Open it",
    "useCommand": "Use a command instead"
  },
  "device": {
    "keyFingerprint": "Key fingerprint",
    "label": "Computer name",
    "platform": "System",
    "version": "DMW Connector version"
  },
  "download": {
    "button": "Download DMW Connector {{version}} for {{system}} ({{size}} MB)",
    "commandElsewhere": "On Linux or macOS, in a terminal there:",
    "commandNote": "Paste it into a terminal on this PC (on a Mac, the Terminal app). It installs the DMW Connector for you alone, without administrator rights, and starts it whenever you sign in.",
    "connect": "Open DMW Connector",
    "copyCommand": "Copy command",
    "linuxNote": "After downloading, allow the file to run as a program.",
    "macNote": "Not signed by Apple: macOS blocks it the first time. Open System Settings › Privacy & Security and choose Open Anyway.",
    "none": "This server offers no installer yet.",
    "noneAdministrator": "Publish a DMW Connector release in its release folder (threads.connector_hub.release_folder).",
    "noneForSystem": "There is no installer for this system yet. Use a command instead, below.",
    "noneMember": "Ask your administrator to publish one.",
    "nothingOpened": "Nothing opened? Install the DMW Connector first, then try again.",
    "otherSystems": "Other systems:",
    "windowsNote": "Not signed yet: Windows says “Windows protected your PC”. Choose More info, then Run anyway. It installs for you alone, without administrator rights."
  },
  "list": {
    "connectAnother": "Connect another PC",
    "details": "Details",
    "enterCode": "Enter a code",
    "getConnector": "Get DMW Connector",
    "getVersion": "Get {{version}}",
    "hideDetails": "Hide details",
    "intro": "Your PC runs the agents of your Runs, with your own accounts.",
    "lastSeen": "Last seen {{when}}",
    "loadFailed": "Your PC list couldn't be loaded",
    "neverSeen": "Not connected yet",
    "noPc": "No PC is connected to your account yet.",
    "online": "Connected",
    "pairedAt": "Paired",
    "pcName": "PC name",
    "rename": "Rename",
    "revoke": "Revoke",
    "revokeConfirm": "Revoke DMW Connector",
    "revokeConfirmMessage": "Revoke “{{label}}”? It is disconnected and can no longer connect. This cannot be undone; to use the PC again, pair it anew.",
    "revokeConfirmTitle": "Revoke “{{label}}”",
    "revoking": "Revoking…",
    "saveName": "Save name",
    "startOn": "Start DMW Connector from the Start menu on {{pc}}.",
    "startService": "Start it on {{pc}} with systemctl --user start dmw-connector; dmw-connector status there says why it isn't connected.",
    "thisPc": "This PC",
    "title": "Connect this PC",
    "toolApproval": {
      "askInApp": "Ask in the app",
      "askInAppHint": "A Run asks you before a new tool version runs on this PC.",
      "automatic": "Automatic",
      "automaticHint": "New tool versions run on this PC without asking.",
      "label": "Tool approval"
    },
    "update": "Update to {{version}}",
    "updating": "Updating…",
    "useComputerName": "Use the computer's name ({{name}})",
    "yourPcs": "Your PCs"
  },
  "models": {
    "contextSize": {
      "hint_one": "The agent itself estimates {{tokens}} token. That estimate is not used on its own.",
      "hint_other": "The agent itself estimates {{tokens}} tokens. That estimate is not used on its own.",
      "itemName": "Context size of {{model}}",
      "needsNumber": "Enter a whole number of tokens, above 0.",
      "note": "Where you read it",
      "notePlaceholder": "For example: the provider's page for this LLM",
      "question": "Enter the context window reported by the LLM provider.",
      "reviewNotice": "Goes into a change set as a capability corrections item. Curators review it like any item.",
      "title": "Context size of {{model}} is unknown",
      "tokens": "Context size (tokens)"
    }
  },
  "pairCommand": {
    "notConfigured": "This server has no DMW Connector address configured (threads.connector_hub.public_origin), so DMW Connectors cannot pair yet. Ask its administrator."
  },
  "pairing": {
    "account": "Your account",
    "accountValue": "{{displayName}} ({{email}})",
    "approve": "Approve pairing",
    "approvedMessage": "“{{label}}” is now paired with your account. The DMW Connector notices this on its own at its next check; you can close this page.",
    "approvedTitle": "DMW Connector paired",
    "approving": "Approving…",
    "closed": {
      "approved": {
        "message": "The pairing of “{{label}}” has been approved before. If you approved it, the DMW Connector is in your list of DMW Connectors.",
        "title": "This code was approved already"
      },
      "denied": {
        "message": "The pairing of “{{label}}” has been denied. To pair this PC, start pairing again on it.",
        "title": "This code was denied already"
      },
      "expired": {
        "message": "Codes are valid for a few minutes only. To pair “{{label}}”, start pairing again on that PC.",
        "title": "This code has expired"
      }
    },
    "code": "Code",
    "codeHelp": "Eight letters. Upper or lower case and the hyphen do not matter.",
    "codeInvalidCharacter": "“{{character}}” never appears in a code. Codes use only these letters: {{alphabet}}.",
    "codeLabel": "Code from the DMW Connector",
    "codeWrongLength": "A code has eight letters; this one has {{letterCount}}.",
    "deniedMessage": "Nothing was paired. The DMW Connector on “{{label}}” is told that the pairing was denied.",
    "deniedTitle": "Pairing denied",
    "deny": "Deny",
    "denying": "Denying…",
    "expiresAt": "Code valid until",
    "intro": "Your DMW Connector shows a code such as WDJB-MJHT. Enter it here to see which PC asks to be paired, then approve or deny it.",
    "lookUp": "Show the request",
    "lookingUp": "Looking up the code…",
    "otherCode": "Enter another code",
    "requestTitle": "This PC asks to be paired with your account",
    "requestedAt": "Requested",
    "selfReported": "The PC name, system and version are what the DMW Connector reports about itself.",
    "server": "DMW server",
    "title": "Connect a PC: enter its code",
    "warningMessage": "Approve only if you have just started the DMW Connector on your PC and it shows the code {{userCode}}. If someone sent you this link or code, deny it: approving would let their PC work under your account.",
    "warningTitle": "Approve only a pairing you started yourself"
  },
  "pcPage": {
    "answers": {
      "noAnswer": "{{pc}} didn't answer. Check that the DMW Connector runs there.",
      "noBrowser": "{{pc}} can't open a browser. Open the DMW Connector there.",
      "noPage": "{{pc}} has its own page turned off.",
      "offline": "{{pc}} went offline. Start the DMW Connector there.",
      "opened": "Opened on {{pc}}.",
      "signInOpen": "A sign-in is open on {{pc}} already. Finish it there in the browser.",
      "signInStarted": "The sign-in opened on {{pc}}. Finish it there in the browser.",
      "tooSoon": "Asked {{pc}} a moment ago: look there, or try again in a few seconds.",
      "updateNeeded": "Update the DMW Connector on {{pc}} to open its page from here."
    },
    "asking": "Asking {{pc}}…"
  },
  "providers": {
    "addKeyOn": "Add a key on {{pc}}",
    "apiKey": "API key",
    "inTerminal": "In a terminal on {{pcs}}:",
    "models_one": "{{count}} LLM",
    "models_other": "{{count}} LLMs",
    "none": "No PC has reported its agents yet. Set up your PC, and they show up here.",
    "perPc": "On each PC",
    "setUpOn": "Set up on {{pc}}",
    "signInOn": "Sign in on {{pc}}",
    "states": {
      "needs_key": "Key needed",
      "needs_sign_in": "Sign-in needed",
      "not_installed": "Not installed",
      "not_working": "Not working",
      "offline": "PC offline",
      "ready": "Ready"
    },
    "title": "Agents and API keys"
  },
  "routes": {
    "agent": "Agent (ACP)",
    "apiKinds": {
      "anthropic": "Anthropic",
      "gemini": "Gemini",
      "openai": "OpenAI",
      "openai_compatible": "OpenAI-compatible"
    },
    "catalogueFailed": "Its LLM catalogue could not be read.",
    "catalogueLeftOut": "LLM catalogue: {{reported}}; {{invalid}} invalid and {{overBudget}} over the report's limit left out.",
    "factCount_one": "{{count}} fact reported",
    "factCount_other": "{{count}} facts reported",
    "factsOmitted_one": "{{count}} fact about it did not fit the report's limit, shared by every LLM route of this PC, and was left out; it does not block turns.",
    "factsOmitted_other": "{{count}} facts about it did not fit the report's limit, shared by every LLM route of this PC, and were left out; they do not block turns.",
    "gta": "API routes run through GTA {{version}} ({{revision}}).",
    "gtaNotStarted": "GTA, which runs the API routes, has not started yet.",
    "kind": "Runs through",
    "missingKey": "missing key",
    "models": "LLMs",
    "noFacts": "none yet",
    "none": "None configured",
    "providerStates": {
      "insufficient_credits": "out of credit",
      "invalid_key": "key refused",
      "ok": "ready",
      "rate_limited": "rate limited",
      "unavailable": "provider unavailable"
    },
    "route": "LLM route",
    "skipped": "Turns skip this LLM route and use the Run's next allowed LLM route.",
    "sources": "Capability facts",
    "status": "Status",
    "title": "Agents and API routes"
  },
  "setup": {
    "agents": {"needOne": "You need at least one agent or API key that is ready."},
    "button": {
      "cloudNeedsPermission": "Without a DMW Connector on your PC, cloud LLMs run only on the server's API keys, and only for the groups a project names in its settings. Ask a project administrator to add you, or connect your PC.",
      "label": "Connect this PC",
      "nothingRunsTitle": "Nothing of yours is connected"
    },
    "check": "Check again",
    "continue": "Continue setup",
    "done": {
      "body": "Your DMW Connector can run Runs now.",
      "connectors": "Your DMW Connectors",
      "startThread": "Start a Run on a document",
      "title": "This PC is ready"
    },
    "followCurrent": "Go to the current step",
    "later": "Do this later",
    "pair": {"waiting": "Waiting for your DMW Connector…"},
    "serverAddress": {
      "administrator": "Set threads.connector_hub.public_origin to this server's public address, then restart the server. DMW Connectors pair with that address.",
      "member": "Waiting for your administrator to set the server address."
    },
    "start": {"body": "The DMW Connector on {{pcs}} starts by itself after pairing and connects."},
    "status": {
      "current": "current step",
      "done": "done",
      "not_applicable": "not needed",
      "to_do": "to do",
      "waiting_for_administrator": "waiting for your administrator"
    },
    "steps": {
      "agents": "Agents and API keys",
      "done": "Done",
      "pair": "Get the DMW Connector and pair it",
      "server_address": "Server address",
      "start": "Start it",
      "welcome": "Welcome"
    },
    "stepsLabel": "Setup steps",
    "title": "Set up this PC",
    "welcome": {
      "body": "Use your own agent subscriptions and API keys on this PC.",
      "notNow": "Not now, I only read and review",
      "start": "Set up this PC"
    }
  },
  "thisPc": {
    "iAmHere": "I'm here",
    "noneOfThem": "None of them",
    "notThisPc": "Not this PC",
    "otherPcs": "Other PCs",
    "which": "Which one are you at?"
  }
}
